import script from "./OrderQuotableButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderQuotableButton.vue?vue&type=script&setup=true&lang=ts"

import "./OrderQuotableButton.vue?vue&type=style&index=0&id=382da91d&scoped=true&lang=css"
import "./OrderQuotableButton.vue?vue&type=style&index=1&id=382da91d&lang=css"

import exportComponent from "C:\\atto\\atto-chempanda\\chempanda\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-382da91d"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
